// use those globals when you need defaults to not rerender component on every tick
export const EMPTY_OBJECT = {};
export const EMPTY_ARRAY = [];
export const EMPTY_FUNCTION = /* istanbul ignore next */ () => null;
